import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { BidSearchResultComponent } from '@shared/components/bid-search-result/bid-search-result.component';
import { SharedModule } from '@shared/shared.module';
import { NgxMaskDirective } from 'ngx-mask';
import { PromoterRoutingModule } from './promoter-routing.module';
import { PromoterComponent } from './promoter.component';

@NgModule({
  declarations: [
    PromoterComponent
  ],
  imports: [
    CommonModule,
    PromoterRoutingModule,
    SharedModule,
    FormsModule,
    FontAwesomeModule,
    NgxMaskDirective,
    BidSearchResultComponent
  ]
})
export class PromoterModule { }
